import React from "react";
import { useParams } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import LoginPage from "pages/auth/LoginPage";

import BackgroundAsImageHero from "components/hero/BackgroundAsImage";

import LandingFooter from "components/footers/LandingFooter";

export const components = {
  innerPages: {
    LoginPage: {
      component: LoginPage,
      scrollAnimationDisabled: true,
      url: "/components/innerPages/LoginPage",
    },
  },

  blocks: {
    Hero: {
      type: "Hero Section",
      elements: {
        BackgroundAsImage: {
          name: "With Background Image",
          component: BackgroundAsImageHero,
          url: "/components/blocks/Hero/BackgroundAsImage",
        },
      },
    },

    Footer: {
      type: "Footers Section",
      elements: {
        LandingFooter: {
          name: "Landing Footer",
          component: LandingFooter,
          url: "/components/blocks/Footer/LandingFooter",
        },
      },
    },
  },
};

export default () => {
  const { type, subtype, name } = useParams();

  try {
    let Component = null;
    if (type === "blocks" && subtype) {
      Component = components[type][subtype]["elements"][name].component;
      return (
        <AnimationRevealPage disabled>
          <Component />
        </AnimationRevealPage>
      );
    } else Component = components[type][name].component;

    if (Component) return <Component />;

    throw new Error("Component Not Found");
  } catch (e) {
    console.log(e);
    return <div>Error: Component Not Found</div>;
  }
};
